import styled from 'styled-components'
import {Input, Layout, Menu} from 'antd'


export const Header = styled(Layout.Header)`
    position: sticky;
    top: 0;
    z-index: 1;
    height: 54px;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-color: #0000001a;
    background-color: #FFFFFF;
    box-shadow: 0 0 #0000, 0 0 #0000, 0 0 #0000, 0 0 #0000, 0 1px 3px 0 #0000001a, 0 1px 2px -1px #0000001a;
`


export const SideSearch = styled(Input)`
    width: 100%;
    border: 1px solid #789fc9;
    height: 38px;
`